import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.5 19h-5.5a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4","key":"svg-0"}],["path",{"d":"M7 15h5","key":"svg-1"}],["path",{"d":"M17 12h-3","key":"svg-2"}],["path",{"d":"M11 12h-1","key":"svg-3"}],["path",{"d":"M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5","key":"svg-4"}]]

const IconSubtitlesAi = createReactComponent('outline', 'subtitles-ai', 'SubtitlesAi', __iconNode);

export default IconSubtitlesAi;